module.exports = {"321112001":"高资街道","321112100":"高桥镇","321112101":"辛丰镇","321112102":"谷阳镇","321112103":"上党镇","321112104":"宝堰镇","321112105":"世业镇","321112400":"宜城街道","321112401":"江心洲生态农业园区","321112402":"荣炳盐资源区","321112403":"高新园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321112.json
// module id = 923
// module chunks = 0